import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TeachersTable from './TeachersTable';
const Teachers = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Teachers' parent='Teachers'  />
      <Container fluid={true}>
        <Row>
          <TeachersTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Teachers;
